import React from 'react';
import IconComponent from '../IconComponents/IconComponent';
import { FlexCenter } from '../../layout/FlexCenter/FlexCenter';

interface IStatusListIconsProps {
    statusList: string[];
    iconSize?: number;
}

export const StatusListIcons: React.FC<IStatusListIconsProps> = ({ statusList, iconSize = 1.6 }) => {
    const createStatusListIcons = statusList?.map((item: string, idx: number)=>{
        return <IconComponent key={idx} size={iconSize} iconName={item}/>
    })

    return (
        <FlexCenter direction='v' gap={0.3}>
            {createStatusListIcons}
        </FlexCenter>
    );
};
